import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class EqualIcon extends BaseIcon {
  getChildren = () => [
    <circle fill={ this.getColor() } cx="8.5" cy="5.5" r="1.5"/>,
    <circle fill={ this.getColor() } cx="8.5" cy="10.5" r="1.5"/>
        ]
  getViewBox = () => '0 0 16 16'
}
